/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SriSubCategory } from './SriSubCategory';
import {
    SriSubCategoryFromJSON,
    SriSubCategoryFromJSONTyped,
    SriSubCategoryToJSON,
} from './SriSubCategory';

/**
 * 
 * @export
 * @interface SriCategory
 */
export interface SriCategory {
    /**
     * 
     * @type {string}
     * @memberof SriCategory
     */
    sriCategoryId: string;
    /**
     * 
     * @type {string}
     * @memberof SriCategory
     */
    sriCategoryLabel: string;
    /**
     * 
     * @type {Array<SriSubCategory>}
     * @memberof SriCategory
     */
    subCategories: Array<SriSubCategory>;
}

/**
 * Check if a given object implements the SriCategory interface.
 */
export function instanceOfSriCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sriCategoryId" in value;
    isInstance = isInstance && "sriCategoryLabel" in value;
    isInstance = isInstance && "subCategories" in value;

    return isInstance;
}

export function SriCategoryFromJSON(json: any): SriCategory {
    return SriCategoryFromJSONTyped(json, false);
}

export function SriCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SriCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sriCategoryId': json['sri_category_id'],
        'sriCategoryLabel': json['sri_category_label'],
        'subCategories': ((json['sub_categories'] as Array<any>).map(SriSubCategoryFromJSON)),
    };
}

export function SriCategoryToJSON(value?: SriCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sri_category_id': value.sriCategoryId,
        'sri_category_label': value.sriCategoryLabel,
        'sub_categories': ((value.subCategories as Array<any>).map(SriSubCategoryToJSON)),
    };
}

